import type { ParseKeys, TFunction } from 'i18next';
import { type SearchFilterRequestPropertyTypeSubType, type SearchListingsFilters } from '@pkgs/api';

import { normalizeTranslationKeyPart } from '@/utils/propertyDataUtils';
import { type TRANSLATION_NAMESPACE } from '@/i18n/config';

type SearchModuleTranslationKey = ParseKeys<typeof TRANSLATION_NAMESPACE.search_module>;
type SearchFilterPropertyTypeKey = keyof SearchFilterRequestPropertyTypeSubType;
type NormalizedPropertyTypeKey = Exclude<SearchFilterPropertyTypeKey, 'retail services'> | 'retail_services';
type SearchModulePropertyTypeTranslationKey = Extract<SearchModuleTranslationKey, `search.searchbar.advFilter.propertyType.${string}`>;

const getPropertyTypeTranslationKey = (
  propertyTypeSubType?: SearchFilterPropertyTypeKey,
): SearchModulePropertyTypeTranslationKey | undefined => {
  if (!propertyTypeSubType) return;

  const normalizedPropertyTypeSubType = normalizeTranslationKeyPart(propertyTypeSubType) as NormalizedPropertyTypeKey;

  return `search.searchbar.advFilter.propertyType.${normalizedPropertyTypeSubType}` as SearchModulePropertyTypeTranslationKey;
};

export const metaDescriptionsIndex = (
  t: TFunction<typeof TRANSLATION_NAMESPACE.search_module>,
  filters: SearchListingsFilters,
  placeName?: string,
): Record<string, string> & { defaultValue: string } => {
  const propertyTypeSubType = Object.keys(filters.propertyTypeSubType ?? {})[0] as SearchFilterPropertyTypeKey;
  const propertyTypeTranslationKey = getPropertyTypeTranslationKey(propertyTypeSubType);
  const propertyMarketingType = filters.propertyMarketingType[0];

  return {
    city: placeName ? `${placeName}, ` : '',
    propertyType: propertyTypeTranslationKey ? `<span class='ev-headline-search-filter'>${t(propertyTypeTranslationKey)}</span>, ` : '',
    marketingType: `<span class='ev-headline-search-filter'>${propertyMarketingType ? t(`search.searchbar.${propertyMarketingType}`) : ''}</span>`,
    defaultValue: '',
  };
};

export const metaDescriptionsExpose = (marketingDescription = ''): string => {
  const descriptionArray = marketingDescription.replaceAll(/([!.?])\s*(?=[A-Z])/g, '$1|').split('|');

  return `${descriptionArray[0] ?? ''} ${descriptionArray[1] ?? ''}`;
};
